import React from 'react';
import { NotificationDeliveryIndexView } from '../../types/notification_deliveries';
import { observer } from 'mobx-react';
import { DetailedDateTime } from '@sheinc/design-system';
import './notificationDeliveryShowPageHeader.module.scss';
import { ImageApis } from '../../../commonv3/api/images';
import { NotificationCategoryTag } from './NotificationCategoryTag';
import { NotificationDeliveryTestLabel } from './NotificationDeliveryTestLabel';

export type Props = {
  notificationDelivery: NotificationDeliveryIndexView;
};

export const NotificationDeliveryShowPageHeader = observer(({ notificationDelivery }: Props) => {
  const { id, notification, notification_category, important, test_delivery } = notificationDelivery;
  const { thumbnail, scheduled_at, title } = notification;
  const categoryTagColor = important ? 'red' : 'gray';
  return (
    <div styleName="notification-show-page-header" data-id={id}>
      <img styleName="thumbnail" src={ImageApis.getUrlFor(thumbnail)} />
      <div styleName="body">
        <div styleName="notification-category-and-date">
          {notification_category && (
            <NotificationCategoryTag categoryTagColor={categoryTagColor} categoryName={notification_category.name} />
          )}
          {test_delivery && <NotificationDeliveryTestLabel />}
          <div styleName="notification-scheduled-date">
            <DetailedDateTime date={scheduled_at} />
          </div>
        </div>
        <div styleName="notification-title">{title}</div>
      </div>
    </div>
  );
});
